import moment from "moment";

import Model from "./model";

class Billing extends Model {
  /* eslint-disable no-unused-expressions */
  constructor(organizationId, billingId = null) {
    super();
    this._organizationId = organizationId;
    this._billingId = billingId;
    this._billingType = null;
    this._billingDate = null;
    this._receiptCreationDate = null;
    this._billingAmount = null;
    this._billingTax = null;
    this._billingAmountIncludingTax = null;
    this._billingStatus = null;
  }
  /* eslint-enable */

  get organizationId() {
    return this._organizationId;
  }

  set organizationId(value) {
    this._organizationId = value;
  }

  get billingId() {
    return this._billingId;
  }

  set billingId(value) {
    this._billingId = value;
  }

  get billingType() {
    return this._billingType;
  }

  set billingType(value) {
    this._billingType = value;
  }

  get billingDate() {
    return this._billingDate;
  }

  set billingDate(value) {
    this._billingDate = value;
  }

  get receiptCreationDate() {
    return this._receiptCreationDatee;
  }

  set receiptCreationDate(value) {
    this._receiptCreationDatee = value;
  }

  get billingAmount() {
    return this._billingAmount;
  }

  set billingAmount(value) {
    this._billingAmount = value;
  }

  get billingTax() {
    return this._billingTax;
  }

  set billingTax(value) {
    this._billingTax = value;
  }

  get billingAmountIncludingTax() {
    return this._billingAmountIncludingTax;
  }

  set billingAmountIncludingTax(value) {
    this._billingAmountIncludingTax = value;
  }

  get billingStatus() {
    return this._billingStatus;
  }

  set billingStatus(value) {
    this._billingStatus = value;
  }

  json() {
    return {
      ...super.json(),
      organizationId: this.organizationId,
      billingId: this.billingId,
      billingType: this.billingType,
      billingDate: this.billingDate,
      receiptCreationDate: this.receiptCreationDate,
      billingAmount: this.billingAmount,
      billingTax: this.billingTax,
      billingAmountIncludingTax: this.billingAmountIncludingTax,
      billingStatus: this.billingStatus,
    };
  }

  copy() {
    const instance = new Billing(this.organizationId, this.billingId);
    instance.copyProperties(this);
    return instance;
  }

  copyProperties(instance) {
    super.copyProperties(instance);

    this.organizationId = instance.organizationId;
    this.billingId = instance.billingId;
    this.billingType = instance.billingType;
    this.billingDate = instance.billingDate;
    this.receiptCreationDate = instance.receiptCreationDate;
    this.billingAmount = instance.billingAmount;
    this.billingTax = instance.billingTax;
    this.billingAmountIncludingTax = instance.billingAmountIncludingTax;
    this.billingStatus = instance.billingStatus;
  }

  setApiResponseJosn(item) {
    super.setApiResponseJosn(item);
    this.billingType = item.billing_type;
    this.billingDate = item.billing_date;
    this.receiptCreationDate = item.receipt_creation_date;
    this.billingAmount = item.billing_amount;
    this.billingTax = item.billing_tax;
    this.billingAmountIncludingTax = item.billing_amount_including_tax;
    this.billingStatus = item.billing_status;
  }

  static createInstance(item) {
    const organizationId = item.organization_id;
    const billingId = item.billing_id;
    const instance
      = new Billing(organizationId, billingId);
    instance.setApiResponseJosn(item);

    return instance;
  }

  getBillingDateText(format) {
    return Billing.getDateText(this.billingDate, format);
  }

  getBillingConfirmationDateText(format) {
    return moment(Date.parse(this.billingDate)).add(1, "months").format(format);
  }

  getReceiptCreationDateText(format) {
    return Billing.getDateText(this.receiptCreationDate, format);
  }
}

class BillingItem extends Model {
  /* eslint-disable no-unused-expressions */
  constructor(billingId, billingItemId = null) {
    super();
    this._billingId = billingId;
    this._billingItemId = billingItemId;
    this._billingItemName = null;
    this._billingItemType = null;
    this._billingAmount = null;
    this._billingItemStatus = null;
    this._organizationId = null;
  }
  /* eslint-enable */

  get billingId() {
    return this._billingId;
  }

  set billingId(value) {
    this._billingId = value;
  }

  get billingItemId() {
    return this._billingItemId;
  }

  set billingItemId(value) {
    this._billingItemId = value;
  }

  get billingItemName() {
    return this._billingItemName;
  }

  set billingItemName(value) {
    this._billingItemName = value;
  }

  get billingItemType() {
    return this._billingItemType;
  }

  set billingItemType(value) {
    this._billingItemType = value;
  }

  get billingAmount() {
    return this._billingAmount;
  }

  set billingAmount(value) {
    this._billingAmount = value;
  }

  get billingItemStatus() {
    return this._billingItemStatus;
  }

  set billingItemStatus(value) {
    this._billingItemStatus = value;
  }

  get organizationId() {
    return this._organizationId;
  }

  set organizationId(value) {
    this._organizationId = value;
  }

  json() {
    return {
      ...super.json(),
      billingId: this.billingId,
      billingItemId: this.billingItemId,
      billingItemName: this.billingItemName,
      billingItemType: this.billingItemType,
      billingAmount: this.billingAmount,
      billingItemStatus: this.billingItemStatus,
      organizationId: this.organizationId,
    };
  }

  copy() {
    const instance = new BillingItem(this.organizationId, this.billingId);
    instance.copyProperties(this);
    return instance;
  }

  copyProperties(instance) {
    super.copyProperties(instance);
    this.billingItemName = instance.billingItemName;
    this.billingItemType = instance.billingItemType;
    this.billingAmount = instance.billingAmount;
    this.billingItemStatus = instance.billingItemStatus;
    this.organizationId = instance.organizationId;
  }

  setApiResponseJosn(item) {
    super.setApiResponseJosn(item);

    this.billingItemName = item.billing_item_name;
    this.billingItemType = item.billing_item_type;
    this.billingAmount = item.billing_amount;
    this.billingItemStatus = item.billing_item_status;
    this.organizationId = item.organization_id;
  }

  static createInstance(item) {
    const billingId = item.billing_id;
    const billingItemId = item.billing_item_id;
    const instance
      = new BillingItem(billingId, billingItemId);
    instance.setApiResponseJosn(item);

    return instance;
  }
}

class PaymentHistory extends Model {
  /* eslint-disable no-unused-expressions */
  constructor(organizationId, billingId = null) {
    super();
    this._organizationId = organizationId;
    this._billingId = billingId;
    this._billingDate = null;
    this._issueDate = null;
    this._issueType = null;
    this._billingType = null;
    this._billingAmount = null;
    this._billingTax = null;
    this._billingAmountIncludingTax = null;
  }
  /* eslint-enable */

  get organizationId() {
    return this._organizationId;
  }

  set organizationId(value) {
    this._organizationId = value;
  }

  get billingId() {
    return this._billingId;
  }

  set billingId(value) {
    this._billingId = value;
  }

  get billingDate() {
    return this._billingDate;
  }

  set billingDate(value) {
    this._billingDate = value;
  }

  get issueDate() {
    return this._issueDate;
  }

  set issueDate(value) {
    this._issueDate = value;
  }

  get issueType() {
    return this._issueType;
  }

  set issueType(value) {
    this._issueType = value;
  }

  get billingType() {
    return this._billingType;
  }

  set billingType(value) {
    this._billingType = value;
  }

  get billingAmount() {
    return this._billingAmount;
  }

  set billingAmount(value) {
    this._billingAmount = value;
  }

  get billingTax() {
    return this._billingTax;
  }

  set billingTax(value) {
    this._billingTax = value;
  }

  get billingAmountIncludingTax() {
    return this._billingAmountIncludingTax;
  }

  set billingAmountIncludingTax(value) {
    this._billingAmountIncludingTax = value;
  }

  json() {
    return {
      ...super.json(),
      organizationId: this.organizationId,
      billingId: this.billingId,
      billingDate: this.billingDate,
      issueDate: this.issueDate,
      issueType: this.issueType,
      billingType: this.billingType,
      billingAmount: this.billingAmount,
      billingTax: this.billingTax,
      billingAmountIncludingTax: this.billingAmountIncludingTax,
    };
  }

  copy() {
    const instance = new PaymentHistory(this.organizationId, this.billingId);
    instance.copyProperties(this);
    return instance;
  }

  copyProperties(instance) {
    super.copyProperties(instance);

    this.organizationId = instance.organizationId;
    this.billingId = instance.billingId;
    this.billingDate = instance.billingDate;
    this.issueDate = instance.issueDate;
    this.issueType = instance.issueType;
    this.billingType = instance.billingType;
    this.billingAmount = instance.billingAmount;
    this.billingTax = instance.billingTax;
    this.billingAmountIncludingTax = instance.billingAmountIncludingTax;
  }

  setApiResponseJosn(item) {
    super.setApiResponseJosn(item);
    this.billingDate = item.billing_date;
    this.issueDate = item.issue_date;
    this.issueType = item.issue_type;
    this.billingType = item.billing_type;
    this.billingAmount = item.billing_amount;
    this.billingTax = item.billing_tax;
    this.billingAmountIncludingTax = item.billing_amount_including_tax;
  }

  static createInstance(item) {
    const organizationId = item.organization_id;
    const billingId = item.billing_id;
    const paymentHistory
      = new PaymentHistory(organizationId, billingId);
    paymentHistory.setApiResponseJosn(item);

    return paymentHistory;
  }

  getIssueDate() {
    return PaymentHistory.getDateText(this.issueDate);
  }

  getBillingDateText(format = "YYYY/MM/DD") {
    return PaymentHistory.getDateText(this.billingDate, format);
  }

  getIssueTypeText() {
    let res = "-";
    if (this.issueType === "invoice") {
      res = "請求書";
    } else if (this.issueType === "receipt") {
      res = "領収書";
    }
    return res;
  }
}

export {
  Billing,
  BillingItem,
  PaymentHistory,
};
